export enum PaymentPurposeKeys {
  LAST_PAYMENT_PURPOSE = "LAST_PAYMENT_PURPOSE",
}

const paymentPurposeService = () => {
  const getPaymentPurpose = (): string | null => {
    return localStorage.getItem(PaymentPurposeKeys.LAST_PAYMENT_PURPOSE);
  };

  const savePaymentPurpose = (purpose: string) => {
    localStorage.setItem(PaymentPurposeKeys.LAST_PAYMENT_PURPOSE, purpose);
  };

  const clearPaymentPurpose = () => {
    localStorage.removeItem(PaymentPurposeKeys.LAST_PAYMENT_PURPOSE);
  };

  return {
    savePaymentPurpose,
    getPaymentPurpose,
    clearPaymentPurpose,
  };
};

export default paymentPurposeService;
